import { useCallback } from 'react'

import { Ok } from 'ts-results'

import { pageSize as defaultPageSize } from 'app/application/constants'
import { useApi } from 'app/common/application'
import { useConnections } from 'app/connections/application'

import {
  TreatmentsGetContent,
  TreatmentsGetRequest,
  TreatmentsGetResponse,
  mapToTreatments,
} from '../types'

const useTreatments = () => {
  const { create } = useApi()
  const { connections } = useConnections()

  const getTreatmentsPage = useCallback(
    (content: TreatmentsGetContent, page = 1, pageSize = defaultPageSize) =>
      create<TreatmentsGetRequest, TreatmentsGetResponse>('/treatments/query', {
        content,
        pagination: {
          page,
          limit: pageSize,
        },
      }).then((result) =>
        result.ok
          ? Ok({ ...result.val, data: mapToTreatments(result.val.data, connections) })
          : result,
      ),
    [create, connections],
  )

  const getTreatments = useCallback(
    (content: TreatmentsGetContent, page = 1, pageSize = defaultPageSize) =>
      getTreatmentsPage(content, page, pageSize).then((result) =>
        result.ok ? Ok(result.val.data) : result,
      ),
    [getTreatmentsPage],
  )

  return {
    getTreatmentsPage,
    getTreatments,
  }
}

export default useTreatments
